var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 13.3334C9.00002 13.8856 9.44774 14.3334 10 14.3334C10.5523 14.3334 11 13.8856 11 13.3334H9.00002ZM11 10C11 9.44774 10.5523 9.00002 10 9.00002C9.44774 9.00002 9.00002 9.44774 9.00002 10H11ZM10 5.66669C9.44774 5.66669 9.00002 6.1144 9.00002 6.66669C9.00002 7.21897 9.44774 7.66669 10 7.66669V5.66669ZM10.0084 7.66669C10.5606 7.66669 11.0084 7.21897 11.0084 6.66669C11.0084 6.1144 10.5606 5.66669 10.0084 5.66669V7.66669ZM17.3334 10C17.3334 14.0501 14.0501 17.3334 10 17.3334V19.3334C15.1547 19.3334 19.3334 15.1547 19.3334 10H17.3334ZM10 17.3334C5.94993 17.3334 2.66669 14.0501 2.66669 10H0.666687C0.666687 15.1547 4.84536 19.3334 10 19.3334V17.3334ZM2.66669 10C2.66669 5.94993 5.94993 2.66669 10 2.66669V0.666687C4.84536 0.666687 0.666687 4.84536 0.666687 10H2.66669ZM10 2.66669C14.0501 2.66669 17.3334 5.94993 17.3334 10H19.3334C19.3334 4.84536 15.1547 0.666687 10 0.666687V2.66669ZM11 13.3334V10H9.00002V13.3334H11ZM10 7.66669H10.0084V5.66669H10V7.66669Z",
    fill: "#5D70BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f348fb2c5d966c243b76b147cbc2fdd0.svg";
export { ForwardRef as ReactComponent };